import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {RouteData} from "../shared/services/route-data/route-data";
import {Subscription} from "rxjs";
import {RouteDataService} from "../shared/services/route-data/route-data.service";
import {UserSubscription, UserSubscriptionType, UserSubscriptionIds} from "../user/user-subscription";
// import {MalihuScrollbarService} from "ngx-malihu-scrollbar";
import {Config} from "../config/config";
import {filter, first, switchMap} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {Website} from "../websites/website/website";
import * as fromStore from '../store';
import {combineLatest} from "rxjs";
import {User} from "../user/user";
import {Utils} from "../shared/utils/utils";


@Component({
    selector: 'db-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    standalone: false
})
export class AccountComponent implements OnInit, OnDestroy, AfterViewInit {

  private _subscriptions: Subscription[];
  public routeData: RouteData;
  public user: User;
  public accountTab: any;
  public currentSubscription: UserSubscription;
  public UserSubscriptionType = UserSubscriptionType;
  public aiStarterAnnual: UserSubscription;
  public websiteCopied: boolean = false;
  public UserSubscriptionIds: any = UserSubscriptionIds;

  public isScrolled: boolean;
  public position: number = 50;
  public scrolled: number = 50;
  public isMobile: boolean = false;
  public demoUser: boolean;

  constructor(
    private _location: Location,
    private router: Router,
    private _route: ActivatedRoute,
    // private _malihuScrollbarService: MalihuScrollbarService,
    private _store: Store<fromStore.DbStoreState>,
    private _routeDataService: RouteDataService,
  ) {}

  ngOnInit(): void {
    this.routeData = this._routeDataService.getCurrentRouteData();
    this.currentSubscription = this._route.snapshot.data['userSubscription'];
    this.accountTab = this._route.snapshot.params['tabId'];
    if (!['account-settings', 'security', 'workspace-access'].includes(this.accountTab)) {
      this.router.navigate(['/404'], {skipLocationChange: true, replaceUrl: true});
    }
    this.addEventHandlers();
    if (window.innerWidth < 991) {
      this.isMobile = true;
    }
  }

  ngAfterViewInit(): void {
      // document.getElementById("db-panel__body") && this._malihuScrollbarService.initScrollbar(document.getElementById("db-panel__body"), Object.assign(Config.malihuScrollbarDefaultOptions, {
      //   callbacks: {
      //     onScroll: () => {
      //       const offsetTop = <HTMLElement> document.querySelector('.db-panel__body .mCSB_container');
      //       if (offsetTop && (this.accountTab === 'billing' || this.accountTab === 'payment-history' || this.accountTab === 'account-settings' || this.accountTab === 'subscription-plan')) {
      //         this.scrolled = 1 - offsetTop.offsetTop;
      //         /*if (this.scrolled >= this.position) {*/
      //         const offsetElement = (<HTMLElement>document.getElementsByTagName("db-" + this.accountTab)[0]);
      //         if (offsetElement) {
      //           if (this.scrolled > 10) {
      //             offsetElement.classList.add("isScrolled");
      //           } else {
      //             offsetElement.classList.remove("isScrolled");
      //           }
      //           if (this.scrolled > 40) {
      //             offsetElement.classList.add("isScrolledMobile");
      //           } else {
      //             offsetElement.classList.remove("isScrolledMobile");
      //           }
      //
      //         }
      //         setTimeout(() => {
      //           this.position = this.scrolled;
      //         }, 100);
      //       }
      //     }
      //   }
      // }));
  }

  private addEventHandlers(): void {
    this._subscriptions = [];
    this._subscriptions.push(this.router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.routeData = this._routeDataService.getCurrentRouteData();
      }));
    this._subscriptions.push(this._route.params.subscribe(params => {
      this.accountTab = this._route.snapshot.params['tabId'];
    }));

    this._subscriptions.push(
      this._store.select(fromStore.getWebsitesLoaded)
        .pipe(
          filter((websitesLoaded: boolean) => websitesLoaded),
          switchMap(() => this._store.select(fromStore.getHostedWebsites)),
          filter((hostedWebsites: Website[]): boolean => !!hostedWebsites.length)
        )
        .subscribe((hostedWebsites: Website[]) => {
          this.websiteCopied = true;
        })
    );

    this._subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          first(loaded => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getUser),
            this._store.select(fromStore.getUserSubscription),
            this._store.select(fromStore.getUserAvailableSubscription(Config.availableSubscriptionId, true))
          )),
          first()
        )
        .subscribe(([user, userSubscription, availableSubscription]) => {
          this.user = user;
          this.currentSubscription = userSubscription;
          this.aiStarterAnnual = availableSubscription;
          this.demoUser = Utils.isDemoUser(userSubscription, user);
        })
    );
  }

  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    this._subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this._subscriptions = null;
  }
  public accountsTabChange($event): void {
    this.accountTab = $event.tabId;
    this.router.navigate(['../' + $event.tabId], {relativeTo: this._route, skipLocationChange: false, replaceUrl: true});
  }

}
